import React, { useEffect, useState } from "react";
import "./styles.scss";

const ServerDownView: React.FC = () => {
  const [dots, setDots] = useState("");
  const [isRetrying, setIsRetrying] = useState(false);

  // Animated dots effect
  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => {
        if (prev.length >= 3) return "";
        return prev + ".";
      });
    }, 500);

    return () => clearInterval(interval);
  }, []);

  const handleRetry = () => {
    setIsRetrying(true);
    // Simulate retry attempt
    setTimeout(() => {
      setIsRetrying(false);
      window.location.reload();
    }, 2000);
  };

  return (
    <div className="server-down-container">
      <div className="server-down-content">
        {/* Animated server icon */}
        <div className="server-icon">
          <div className="server-tower">
            <div className="server-lights">
              <div className="light red"></div>
              <div className="light yellow"></div>
              <div className="light green"></div>
            </div>
            <div className="server-body">
              <div className="server-vent"></div>
              <div className="server-vent"></div>
              <div className="server-vent"></div>
            </div>
          </div>
          <div className="server-base"></div>
        </div>

        {/* Main message */}
        <h1 className="main-title">
          Server is currently down
          <span className="dots">{dots}</span>
        </h1>

        <p className="subtitle">
          We're experiencing some technical difficulties. Our team is working hard to get everything
          back up and running.
        </p>

        {/* Status indicators */}
        <div className="status-container">
          <div className="status-item">
            <div className="status-icon error">⚠️</div>
            <span>Server Status: Offline</span>
          </div>
          <div className="status-item">
            <div className="status-icon info">ℹ️</div>
            <span>Estimated Time: Under investigation</span>
          </div>
        </div>

        {/* Action buttons */}
        <div className="action-buttons">
          <button
            className={`retry-button ${isRetrying ? "retrying" : ""}`}
            onClick={handleRetry}
            disabled={isRetrying}
          >
            {isRetrying ? (
              <>
                <div className="spinner"></div>
                Retrying...
              </>
            ) : (
              "Try Again"
            )}
          </button>

          <button className="refresh-button" onClick={() => window.location.reload()}>
            Refresh Page
          </button>
        </div>

        {/* Additional info */}
        <div className="additional-info">
          <p>
            If the problem persists, please check our{" "}
            <a href="#" className="status-link">
              status page
            </a>{" "}
            or contact support.
          </p>
        </div>

        {/* Floating particles for visual appeal */}
        <div className="particles">
          {[...Array(6)].map((_, i) => (
            <div key={i} className={`particle particle-${i + 1}`}></div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServerDownView;
